import React, { createContext, useContext, useState, useCallback } from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Fade from "@mui/material/Fade";
import { TransitionGroup } from "react-transition-group";

const ToastContext = createContext(null);

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((message, severity = "info") => {
    const id = new Date().getTime();
    setToasts((prev) => [...prev, { id, message, severity }]);
    setTimeout(() => removeToast(id), 2000);
  }, []);

  const removeToast = useCallback((id) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id));
  }, []);

  return (
    <ToastContext.Provider value={addToast}>
      {children}

      <TransitionGroup
        style={{
          position: "fixed",
          top: 0,
          bottom: 0,
          right: 0,
          zIndex: 1400,
          display: "flex",
          flexDirection: "column",
          gap: "12px", // spacing between toasts
        }}
      >
        {toasts.map((toast, index) => (
          <Fade key={toast.id} in timeout={{ enter: 300, exit: 600 }}>
            <Snackbar
              open
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
              sx={{
                top: `${60 + index * 50}px !important`, // stacking
                right: '10px!important'
              }}
            >
              <Alert
                onClose={() => removeToast(toast.id)}
                severity={toast.severity}
                sx={{ width: "100%" }}
              >
                {toast.message}
              </Alert>
            </Snackbar>
          </Fade>
        ))}
      </TransitionGroup>
    </ToastContext.Provider>
  );
}

export function useToast() {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error("useToast must be used inside a ToastProvider");
  }
  return context;
}
